// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pzHu","toggleWrap":"styles_toggleWrap__2V4H7","content":"styles_content__31bkc","selectAreaCode":"styles_selectAreaCode__35Kuj"};